import {getTestProps} from '@benchling/js-test-utils';
import {Input, Paper} from '@mantine/core';
import {useId} from '@mantine/hooks';
import React from 'react';

import FolderSelector from 'file-browser/FolderSelector';
import {ZINDEX_FLOATING_UI} from 'styles/StyleConstants';

interface OutputFolderFieldProps {
  folderId: string | null;
  onChange: (folderId: string | null) => void;
}

/** Where the submitted batches are created, which also determines who can see them. */
export default function OutputFolderField({folderId, onChange}: OutputFolderFieldProps): JSX.Element {
  const id = useId();
  return (
    // Narrow on purpose: it's a single choice, and a full-width card would compete with Model and Inputs.
    <Paper maw={320} p="lg" radius="md" {...getTestProps({component: 'OutputFolderField', element: 'root'})}>
      {/* A group rather than a <label>: labelling the button would replace the selected folder name as
          its accessible name. */}
      <Input.Wrapper
        aria-labelledby={`${id}-label`}
        id={id}
        label="Output folder"
        labelElement="div"
        required={true}
        role="group"
      >
        <FolderSelector
          allowNone={false}
          enableRedesign={true}
          level="append"
          noFolderText="Choose folder"
          onChange={(e: {target: {value: string | null}}) => {
            onChange(e.target.value);
          }}
          selectorModalZIndex={ZINDEX_FLOATING_UI as 1060}
          // Required to offer non-root folders.
          showNotebook={true}
          unsetOnFetchFail={true}
          value={folderId}
        />
      </Input.Wrapper>
    </Paper>
  );
}
